<template>
  <div>
    <div class="bg-theme-green border-0 rounded-t-xl px-4 py-2 text-white">
      <div class="flex justify-between">
        <div class="flex justify-between flex-col">
          <h2 class="font-semibold leading-tight truncate text-single-line break-all text-2xl mt-2">{{ item?.firstName ? item.firstName : 'New Customer' }}</h2>
          <p class="text-sm font-semibold tracking-wide mt-4" v-if="item?.points">{{ item.points.toLocaleString() }} Points</p>
        </div>

        <div class="flex flex-col items-end">
            <span @click.prevent="clearComponent" class="cursor-pointer rounded-md  text-white py-2 pl-1  hover:opacity-70">CLOSE</span>
          <div class="flex justify-end">
            <button v-if="can_edit_customer_details_in_admin" @click.prevent="update()" class="text-sm font-medium tracking-widest cursor-pointer bg-white py-2 px-4 rounded text-theme-green hover:bg-theme-darkgreen hover:text-white mr-2">
              <span>SAVE</span>
            </button>
            <button v-if="can_edit_customer_details_in_admin" @click.prevent="remove(item)" class="text-sm font-medium tracking-widest cursor-pointer bg-white py-2 px-4 rounded text-theme-red hover:bg-theme-darkgreen hover:text-white">
              <span>DELETE</span>
            </button>
          </div>
        </div>

      </div>
    </div>

    <div>
        <ul class="flex gap-[54px] bg-[#2B2C32] rounded-b-xl px-2 pt-3 pb-2">
            <li @click="toggle('Customer')" :class="editPage=='Customer'?'active':''">
                <a class="inline-block text-theme-white tracking-widest text-sm font-semibold uppercase" href="#">Customer Profile</a>
            </li>
            <li @click="toggle('History')" :class="editPage=='History'?'active':''">
                <a class="text-theme-dimwhite tracking-widest text-sm font-semibold uppercase" href="#">Sales History</a>
            </li>
        </ul>
    </div>

    <component :is="editPage" :clearComponent="clearComponent" :item="item"/>
  </div>
</template>
<script>
  import { defineComponent, ref} from "vue"
  import Helpers from '@/helpers';
  import Customer from './Update/Customer-Profile.vue';
  import History from './Update/Sale-History.vue';

  export default defineComponent({
    name: "MembershipCustomerUpdate",
    components: {
      Customer,
      History,
    },
    props: {
      clearComponent: {
        type: Function,
        required: true,
      },
      item: {
        type: Object,
        required: true,
      },
    },
    setup() {
      const editPage = ref('Customer')

      return {
        editPage,
      };
    },
    computed: {
      can_edit_customer_details_in_admin() {
        return Helpers.getMyPermission('can_edit_customer_details_in_admin')
      },
    },
    methods: {
      async toggle(name){
        this.editPage = name
      },
      update(){
        this.emitter.emit("update-customer-profile");
      },
      remove(item){
        this.emitter.emit("remove-customer-profile", item);
      }
    }
  });
</script>
<style scoped>
  .active{
      border-bottom: solid 4px #2BA66B;
  }
</style>